import Swiper, {Autoplay, Navigation, Pagination, EffectFade} from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);

export default class OverOns {
    constructor() {
        if (document.querySelector('.employees-slider') !== null) {

            this.employeesSlider();

        }
    }

    employeesSlider() {
        if (document.querySelector('.employees-slider')) {
            new Swiper('.employees-slider .swiper-container', {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: {
                    delay: 3000,
                },
                breakpoints: {
                    360: {
                        slidesPerView: 1.2,
                        spaceBetween: 20
                    },

                    768: {
                        slidesPerView: 2,

                    },
                    1200: {
                        slidesPerView: 3,

                    },
                }
            })
        }
    }




    resizeWindow() {
        let resizeTimer;
        window.addEventListener('resize', e => {
            if (resizeTimer) clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.employeesSlider();
            }, 100, e);
        });
    }

}
